
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 100 100"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M93.774 25.51a27.895 27.895 0 00-6.06-8.88 28.142 28.142 0 00-8.945-5.953A28.085 28.085 0 0067.864 8.5a28.293 28.293 0 00-14.824 4.183 27.76 27.76 0 00-3.035 2.155 27.77 27.77 0 00-3.035-2.155A28.293 28.293 0 0032.146 8.5c-3.78 0-7.444.73-10.905 2.177a28.08 28.08 0 00-8.945 5.952 27.724 27.724 0 00-6.06 8.88A27.665 27.665 0 004 36.437c0 3.572.724 7.293 2.162 11.079 1.203 3.164 2.928 6.445 5.133 9.76 3.493 5.244 8.296 10.713 14.26 16.258 9.882 9.19 19.669 15.54 20.084 15.797l2.524 1.63a3.399 3.399 0 003.674 0l2.524-1.63c.415-.268 10.191-6.606 20.085-15.797 5.963-5.545 10.766-11.014 14.26-16.259 2.203-3.314 3.939-6.595 5.132-9.759C95.276 43.73 96 40.009 96 36.437a27.472 27.472 0 00-2.226-10.928z"}})])
          )
        }
      }
    